import layout from '@/pages/layout/layout'



var ROUNTER_ARR = [
    {
        path: '/layout',
        name: 'layout',
        component: layout,
        children: [
            {
                path: '/home',
                name: 'home',
                component: (resolve) => require(["@/pages/home/home"], resolve),
                meta: { title: '工作台'}
            },
            {
                path: '/agentgrade',
                name: 'agentgrade',
                component: (resolve) => require(["@/pages/agentGrade/agentGrade"], resolve),
                meta: { title: '代理商等级' }
            },
            {
                path: '/agentList',
                name: 'agentList',
                component: (resolve) => require(["@/pages/agentList/agentList"], resolve),
                meta: { title: '代理商列表' }
            },
            {
                path: '/agentList/editAgent',
                name: 'editAgent',
                component: (resolve) => require(["@/pages/agentList/editAgent"], resolve),
                meta: { subtitle: '基础信息'},
                isWhite: true,
            },
            {
                path: '/accountBalance',
                name: 'accountBalance',
                component: (resolve) => require(["@/pages/accountBalance/accountBalance"], resolve),
                meta: { title: '账户余额' }
            },
            {
                path: '/projectSet',
                name: 'projectSet',
                component: (resolve) => require(["@/pages/projectSet/projectSet"], resolve),
                meta: { title: '项目设置' }
            },
            {
                path: '/userInfo',
                name: 'userInfo',
                component: (resolve) => require(["@/pages/userInfo/userInfo"], resolve),
                meta: { title: '个人信息' }
            },
            {
                path: '/customerList',
                name: 'customerList',
                component: (resolve) => require(["@/pages/customerList/customerList"], resolve),
                meta: { title: '客户列表' }
            },
            {
                path: '/customerList/editCustomer',
                name: 'editCustomer',
                component: (resolve) => require(["@/pages/customerList/editCustomer"], resolve),
                meta: { subtitle: '基础信息'},
                isWhite: true,
            },
        ]
    },
    {
        path: '/middlePage',
        name: 'middlePage',
        component: (resolve) => require(["@/pages/login/middlePage"], resolve),
        isWhite: true
    },
    {
        path: '/login',
        name: 'login',
        component: (resolve) => require(["@/pages/login/login"], resolve),
        isWhite: true
    },
    {
        path: '/',
        hidden: true,
        redirect: { path: '/login' }
    }
]
export default ROUNTER_ARR



// WEBPACK FOOTER //
// ./src/router/routerParams.js